import { LitElement, html } from 'lit';
import alertEvents from './alert-events';

// Button to trigger a dialog
class AlertEditButton extends LitElement {
	static get properties() {
		return {
			isin: { type: String },
			id: { type: Number },
			threshold: { type: Number },
			thresholdDirection: { type: Number },
			priceType: { type: Number },
		};
	}

	onButtonClick() {
		const detail = {
			id: this.id,
			threshold: this.threshold,
			priceType: this.priceType,
			isin: this.isin,
			thresholdDirection: this.thresholdDirection,
		};

		const event = new CustomEvent(alertEvents.ALERT_EDIT, {
			bubbles: true,
			detail,
		});

		this.dispatchEvent(event);
	}

	render() {
		return html`
			<div class="manageable-list__item-button">
				<button
					class="button button--ghost button--icon-only button--small"
					@click="${this.onButtonClick}"
				>
					<span class="button__icon">
						<x-icon icon="edit"></x-icon>
					</span>
				</button>
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-alert-edit-button', AlertEditButton);

export default AlertEditButton;
